__turbopack_context__.v({
  "navigation-toggle": "XuuSLW_navigation-toggle",
  "navigation-toggle--open": "XuuSLW_navigation-toggle--open",
  "navigation-toggle__line": "XuuSLW_navigation-toggle__line",
});
